module.exports = __webpack_public_path__ + "img/sfq-h1.321d8b34.png";